import styled from "styled-components";
import {
  COLORS,
  responsive,
} from "../../../../../../../../../../styles/constants.style";

export const SalesCreditDetailsTableHeaderWrapper = styled.div`
  .dashed-line {
    margin: 24px 0px;
    border: 1px dashed ${COLORS.primary_light_blue4};
    ${responsive.MOBILE`
      margin: 16px 0;
    `}
  }
`;
